export const expiredStudentIdSMS = {
  en: 'Your Student ID will expire within one month. Please update it as soon as you can! - Della',
  hu: 'A diákigazolványod érvényessége le fog járni 1 hónapon belül, kérlek frissítsd amint tudod! - Della',
};
